/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The palette is generated in HSL and shown as hex codes, which you can paste directly into CSS, design tools or code.`)
};

const es_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La paleta se genera en HSL y se muestra como códigos hexadecimales, que puedes pegar directamente en CSS, herramientas de diseño o código.`)
};

const de_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Palette wird in HSL erzeugt und als Hex-Codes angezeigt, die du direkt in CSS, Design-Tools oder Code einfügen kannst.`)
};

const nl_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het palet wordt gegenereerd in HSL en getoond als hexcodes, die je direct kunt plakken in CSS, ontwerptools of code.`)
};

const fr_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La palette est générée en HSL et affichée en codes hexadécimaux, que vous pouvez coller directement dans du CSS, des outils de design ou du code.`)
};

const it_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La palette viene generata in HSL e mostrata come codici esadecimali, che puoi incollare direttamente in CSS, strumenti di design o codice.`)
};

const pt_br2_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A paleta é gerada em HSL e exibida como códigos hex, que você pode colar direto em CSS, ferramentas de design ou código.`)
};

const pt_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A paleta é gerada em HSL e apresentada em códigos hex, que pode colar diretamente em CSS, ferramentas de design ou código.`)
};

const ja_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パレットはHSLで生成され、16進数コードとして表示されます。CSSやデザインツール、コードにそのまま貼り付けられます。`)
};

const zh_cp_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配色方案在 HSL 空间中生成，并以十六进制代码显示，你可以直接粘贴到 CSS、设计工具或代码中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_a3", locale)
	if (locale === "en") return en_cp_faq_a3(inputs)
	if (locale === "es") return es_cp_faq_a3(inputs)
	if (locale === "de") return de_cp_faq_a3(inputs)
	if (locale === "nl") return nl_cp_faq_a3(inputs)
	if (locale === "fr") return fr_cp_faq_a3(inputs)
	if (locale === "it") return it_cp_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_a3(inputs)
	if (locale === "pt") return pt_cp_faq_a3(inputs)
	if (locale === "ja") return ja_cp_faq_a3(inputs)
	return zh_cp_faq_a3(inputs)
};